export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '类型',
      dataIndex: 'sourceTypeName',
      key: 'sourceTypeName',
      width: 120,

    },
    {
      title: 'SPU编码',
      dataIndex: 'sourceCode',
      key: 'sourceCode',
      width: 200,
    },
    {
      title: '失败原因',
      dataIndex: 'responseContent',
      key: 'responseContent',
      ellipsis: {
        showTitle: true,
      },
      // render: address => <Tooltip title={address}>{address}</Tooltip>,
    },
  ],
  search: [],
  footer: [],
  batchActions: [],
}
